import * as z from 'zod';

// Same limits as LoginDto in @tixbase/contracts, so the form never sends what the API rejects.
export const loginSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Enter your email')
    .max(255, 'Email is too long')
    .pipe(z.email('Enter a valid email address')),
  password: z.string().min(1, 'Enter your password').max(128, 'Password is too long'),
});

export type LoginValues = z.infer<typeof loginSchema>;
